/**
 * Куда вернуть человека после входа. Только путь этого же сайта: `next` приходит в адресе, и
 * `//evil.example` или `https://…` там превратили бы экран входа в пересылку на чужой сайт.
 */
export const safeNext = (raw: string | null | undefined, fallback: string): string => {
  const value = String(raw ?? '')
  return value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\') ? value : fallback
}

export const loginPath = (next: string) => `/login?next=${encodeURIComponent(next)}`
